import React, { ReactNode } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

interface ProtectedRouteProps {
  children: ReactNode;
  requireOwner?: boolean;
  requireEmployee?: boolean;
}

export const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ 
  children, 
  requireOwner = false, 
  requireEmployee = false 
}) => {
  const { isAuthenticated, isLoading, isOwner, isEmployee } = useAuth();
  const location = useLocation();

  if (isLoading) {
    return (
      <div style={{ 
        display: 'flex', 
        justifyContent: 'center', 
        alignItems: 'center', 
        height: '100vh' 
      }}>
        <div>Carregando...</div>
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/app/login" state={{ from: location }} replace />;
  }

  if (requireOwner && !isOwner) {
    return <Navigate to="/app/login" replace />;
  }

  if (requireEmployee && !isEmployee) {
    return <Navigate to="/app/login" replace />;
  }

  return <>{children}</>;
};
